<template>
    <div class="pd20x flex1">
      <Deliver :visible="deliverOpen" @close="deliverOpen = false"></Deliver>
      <div class="contentBox h100pct ofA">
        <div class="filter" style="padding:10px 20px">
          <!-- <div> 
            <a-button type="primary" @click="openClasses">开课</a-button>
          </div> -->
          <div>
            <label>搜索：</label>
            <a-select v-model="selectVal" style="width: 120px" >
              <a-select-option :value="item.val" v-for="(item,index) in option" :key="index">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-input-search placeholder="请输入搜索内容" v-model="searchInput" style="width: 300px" @search="onSearch" class="mr10px"/>
          </div>
        </div>
        <a-table
          :columns="columns"
          :data-source="data"
          :rowKey="'uid'"
          :pagination="{pageSize: page.pageSize, total}"
          @change="changePage"
        >
          <template slot="headimgurl" slot-scope="text">
            <a-avatar icon="user" :src="text"/>
          </template>
          <template slot="sex" slot-scope="text">
            {{text?'女':'男'}}
          </template>
            <!-- <template slot="status" slot-scope="text">
                <a-date-picker :defaultValue="momentDay(text)" @change="onChange" style="width:130px" />
            </template>
            <template slot="content2" slot-scope="text,record">
                <a-input :defaultValue="text" style="width: 130px" @blur="changeNum(e,record)"></a-input>
            </template> -->
          <template slot="operation" slot-scope="text, record">
            <a-space>
              <!-- <span class="csP" style="color:#7ebae5" >编辑</span>
              <span class="csP" style="color:#7ebae5" >复制</span> -->
              <span class="csP" style="color:#7ebae5" @click="openClasses(record)">开通</span>
              <!-- <span class="csP" style="color:#7ebae5" >发货</span>
              <span class="csP" style="color:#7ebae5" >删除</span> -->
              </a-space>
          </template>
        </a-table>
        <!-- <span class="csP mr10px" style="color:#7ebae5" >编辑</span>
        <span class="csP mr10px" style="color:#7ebae5" >复制</span>
        <span class="csP mr10px" style="color:#7ebae5" >开通</span>
        <span class="csP mr10px" style="color:#7ebae5" @click="deliverOpen = true">发货</span>
        <span class="csP" style="color:#ff5f4e" >删除</span>
        <span class="csP" style="color:#ff5f4e" @click="$router.push('/exam/studentDetail')">学员详情</span> -->
      </div>
    </div>
</template>
<script>
const columns = [
  { title: '学员姓名', dataIndex: 'realname', align: 'center' },
  { title: '头像', dataIndex: 'headimgurl', align: 'center', scopedSlots: { customRender: 'headimgurl' } },
  { title: '昵称', dataIndex: 'nickname', align: 'center' }, 
  { title: '性别', dataIndex: 'sex', scopedSlots: { customRender: 'sex' }, align: 'center' },
  { title: '学号', dataIndex: 'num', align: 'center' },
  { title: '电话', dataIndex: 'phone', align: 'center' }, 
  { title: '邮箱', dataIndex: 'email', align: 'center' }, 
  // { title: '地址', dataIndex: 'content4', align: 'center' }, 
  // { title: '课程包信息', dataIndex: 'content5', align: 'center' }, 
  // { title: '待处理', dataIndex: 'content6', align: 'center' }, 
  // { title: '最近登录时间', dataIndex: 'content2', scopedSlots: { customRender: 'content2' }, align: 'center' },
  { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center' }
];
import Deliver from './student/deliver'
import * as http from '@/libs/examapi'
export default {
    name: 'students',
    components: { Deliver },
    data(){
        this.option = [
          { name: '微信名', val: 'nickname'},
          { name: '学号', val: 'num'},
          { name: '电话', val: 'phone'},
          // { name: '微信号', val: '2'},
          { name: '邮箱', val: 'email'},
          // { name: '地址', val: '4'},
        ]
        return{
          data:[],
          columns,
          searchInput: '',
          selectVal: 'nickname',
          deliverOpen: false,
          currentItem: null,
          filter:{},
          page:{
            pageSize: 15,
            page: 1
          },
          total: 0
        }
    },
    mounted(){
      this.getData()
    },
    methods:{
      getData(){
        http.getUserList({...this.page, ...this.filter}).then(res => {
          let {total, data} = res
          this.data = data
          this.total = total
        })
      },
      openClasses({uid}){
        this.$router.push({
          path: '/exam/courseLimit',
          query:{
            uid
          }
        })
      },
      onSearch(){
        this.filter = {}
        this.filter[this.selectVal] = this.searchInput
        this.getData()
      },
      changePage({current}){
        this.page.page = current
        this.getData()
      }
    }
}
</script>